//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomizeInvitation',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      img: 'https://static.moele.me/img/channels2022/referral/invitation.png?auto=format&w=712',
      imgDark: 'https://static.moele.me/img/channels2022/referral/invitation-dark.png?auto=format&w=712',
    };
  },
};
